// @flow

import type {_Action} from '../../types';

const rootAct = '@publisher/support/disputes/settings';

export const SET_MERCHANT_ID = `${rootAct}/merchantID/set`;
export const SET_USER_TOKEN = `${rootAct}/set-token`;

export const setMerchantID = (payload): _Action<number> => ({
  type: SET_MERCHANT_ID,
  payload
});

export const setUserToken = (payload: string): _Action<string> => ({type: SET_USER_TOKEN, payload});
